module.exports = __webpack_public_path__ + "media/images/tiktok-438878451f031dd0d6ed36e6c0888d28.svg";